//shared containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';
import { Logos, logos_list } from '@/containers-ai/Logos';
import { Proof } from '@/containers-latam/Proof';

//containers
import {
  Hero,
  LiveInProduction,
  ScenarioTheater,
  AgenticWorkflow,
  Rails,
  EndCTA,
} from './containers/index';

//styles
import { PageWrapper, AIGlobalStyle } from './AI.styles';
import { LifecycleRail } from '@/containers-latam/LifecycleRail';
import { FAQ } from '@/containers-latam/FAQ';

function AI({
  hero_content,
  liveInProduction_content,
  freightExperts_content,
  platformScale_content,
  lifecycleRail_content,
  scenarioTheater_content,
  endCta_content,
  agenticWorkflow_content,
  rails_content,
  proof_content,
  faq_content,
  liveTaskHrefs,
  numberLocale,
  nav,
  footer,
}) {
  // LATAM pages follow the copy document's section order and skip the
  // "TMS or YMS" rail and the full Freight Experts block.
  if (faq_content) {
    return (
      <PageWrapper>
        <AIGlobalStyle />
        <Navigation theme="dark" nav={nav} />
        <Hero content={hero_content} />
        <Logos logos={logos_list} label={false} />
        <LiveInProduction
          content={liveInProduction_content}
          platformScaleContent={platformScale_content}
          taskHrefs={liveTaskHrefs}
          ctaHref={endCta_content.ctaHref}
          numberLocale={numberLocale}
        />
        <ScenarioTheater content={scenarioTheater_content} />
        <EndCTA variant="top" content={endCta_content} />
        <AgenticWorkflow content={agenticWorkflow_content} />
        <Rails content={rails_content} />
        <Proof
          outcomes={proof_content.outcomes}
          kicker={proof_content.kicker}
          title={proof_content.title}
          locale={numberLocale}
        />
        <FAQ content={faq_content} />
        <EndCTA variant="bottom" content={endCta_content} />
        <Footer config={footer} />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <AIGlobalStyle />
      <Navigation theme="dark" />
      <Hero content={hero_content} />
      <Logos logos={logos_list} />
      <LiveInProduction
        content={liveInProduction_content}
        freightExpertsContent={freightExperts_content}
        platformScaleContent={platformScale_content}
      />
      <AgenticWorkflow content={agenticWorkflow_content} />
      <EndCTA variant="top" content={endCta_content} />
      <Rails content={rails_content} />
      <ScenarioTheater content={scenarioTheater_content} />
      <Proof
        outcomes={proof_content.outcomes}
        kicker={proof_content.kicker}
        title={proof_content.title}
      />
      <LifecycleRail
        content={lifecycleRail_content}
        platformScaleContent={platformScale_content}
        showPlatformScale={false}
      />
      <EndCTA variant="bottom" content={endCta_content} />
      <Footer />
    </PageWrapper>
  );
}

export default AI;
export { AI };
